import { Factory, Car, Cpu, Zap, Package, Cog } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { homeTranslations } from '../translations/home';

const IndustriesSection = () => {
  const { language } = useLanguage();
  const t = homeTranslations[language].industries;

  const industries = [
    { icon: Zap, name: t.list[0] },
    { icon: Car, name: t.list[1] },
    { icon: Cpu, name: t.list[2] },
    { icon: Package, name: t.list[3] },
    { icon: Cog, name: t.list[4] },
    { icon: Factory, name: t.list[5] }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-black to-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t.title} <span className="text-[#B91C1C]">{t.titleAccent}</span>
          </h2>
          <div className="w-24 h-1 bg-[#B91C1C] mx-auto mt-4 mb-6"></div>
          <p className="text-gray-400 text-lg max-w-3xl mx-auto">
            {t.description}
          </p>
        </div>

        {/* Industries Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {industries.map((industry, index) => {
            const IconComponent = industry.icon;
            return (
              <div 
                key={index}
                className="bg-gray-800/50 border border-gray-700 rounded-lg p-6 flex flex-col items-center justify-center text-center  backdrop-blur-sm"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-[#B91C1C]/20 to-gray-900 rounded-full flex items-center justify-center mb-4 ">
                  <IconComponent className="text-[#B91C1C]" size={28} />
                </div>
                <h3 className="text-white font-semibold text-sm group-hover:text-[#B91C1C] ">
                  {industry.name}
                </h3>
              </div>
            );
          })}
        </div>

        {/* Stats Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-bold text-[#B91C1C] mb-2">12+</div>
            <div className="text-gray-400 text-sm uppercase tracking-wider">{t.stats.years}</div>
          </div>
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-bold text-[#B91C1C] mb-2">500+</div>
            <div className="text-gray-400 text-sm uppercase tracking-wider">{t.stats.projects}</div>
          </div>
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-bold text-[#B91C1C] mb-2">100%</div>
            <div className="text-gray-400 text-sm uppercase tracking-wider">{t.stats.satisfaction}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
